import { Component, OnInit, Output, EventEmitter, ViewChild, TemplateRef, Input, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { ImageSetting } from './image-set';
import { MessagerService } from '@farris/ui-messager';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-image-set',
  templateUrl: './image-set.component.html',
  styleUrls: ['./image-set.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class ImageSetComponent implements OnInit {

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input()
  set value(setValue: any) {
    if (setValue) {
      this.imageSetting.imageOperation = setValue.imageOperation;
      }
    }

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  modalConfig = {
    title: this.localePipe.transform('component.imageSet.imageSet'),
    width: 520,
    height: 360,
    showButtons: true
  };
// 影像操作权限选项列表
  operationList = [
    { value: 'onlyView', name: this.localePipe.transform('component.imageSet.onlyView')},
    { value: 'edit', name: this.localePipe.transform('component.imageSet.edit')},
    { value: 'reScanStart', name: this.localePipe.transform('component.imageSet.reScanStart')},
    { value: 'reScanComplete', name: this.localePipe.transform('component.imageSet.reScanComplete') }];
// 影像操作权限
  imageSetting: ImageSetting = new ImageSetting();
  constructor(
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }

  changeValue(data: any) {
    // 先选0再选123的时候，暂时置为0？先选123再选0则置为0√
    if (data.indexOf('onlyView') > -1) {
      setTimeout(() => {
        this.message.info(this.localePipe.transform('component.imageSet.mutualExclusion'));
        this.imageSetting.imageOperation = 'onlyView';
      }, 100);
    }
  }

  clickOK() {
    const value = this.imageSetting;
    const object = { value, parameters: null };
    this.submitModal.emit(object);
  }

  clickCancel() {
    this.closeModal.emit();
  }

}
export class ImageSetConverter implements TypeConverter {

  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any): string {
    if (data && data.imageOperation) {
      return this.localePipe.transform('component.imageSet.set');
    }
    return this.localePipe.transform('component.imageSet.notSet');
  }
}
